export const hoverStyles = {
    _hover: {
        tablet: {
            backgroundColor: 'transparent',
            borderColor: 'black',
        },
    },
};
// This enables this working on select
export const baseStyles = {
    fontSize: { tablet: 'sm', base: 'xs' },
    display: 'flex',
    alignItems: 'center',
    padding: { tablet: '3', base: '2' },
    borderColor: 'accent',
    fontWeight: 'medium',
    borderRadius: '0.375rem',
    backgroundColor: 'inherit',
    color: 'text.primary',
    gap: 1,
    height: '40px',
    ...hoverStyles,
};
// Below is for buttons, not select
export const styles = {
    lineHeight: '.85',
    ...baseStyles,
};
